const PLAN_CATALOG = [
  {
    id: 'basic-pack',
    name: 'Basic Pack',
    price: '฿319.93 / month',
    priceDisplay: '฿319.93 / month',
    priceAmount: 3839.16,
    billingPeriod: 1,
    billingUnit: 'year',
    productDescription: 'Basic Pack',
    features: [
      '1,500 credits per year',
      '0 bonus credits',
      '1,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    id: 'create-pack',
    name: 'Create Pack',
    price: '฿1,068.93 / month',
    priceDisplay: '฿1,068.93 / month',
    priceAmount: 12827.16,
    billingPeriod: 1,
    billingUnit: 'year',
    productDescription: 'Create Pack',
    features: [
      '5,250 credits per year',
      '250 bonus credits',
      '5,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    id: 'studio-pack',
    name: 'Studio Pack',
    price: '฿1,594.30 / month',
    priceDisplay: '฿1,594.30 / month',
    priceAmount: 19131.6,
    billingPeriod: 1,
    billingUnit: 'year',
    productDescription: 'Studio Pack',
    features: [
      '8,200 credits per year',
      '750 bonus credits',
      '8,950 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    id: 'master-pack',
    name: 'Master Pack',
    price: '฿4,269.30 / month',
    priceDisplay: '฿4,269.30 / month',
    priceAmount: 51231.6,
    billingPeriod: 1,
    billingUnit: 'year',
    productDescription: 'Master Pack',
    features: [
      '22,500 credits per year',
      '2,550 bonus credits',
      '25,050 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    id: 'creator-plus-pack',
    name: 'Creator+ Pack',
    price: '฿10,593.00 / month',
    priceDisplay: '฿10,593.00 / month',
    priceAmount: 127116,
    billingPeriod: 1,
    billingUnit: 'year',
    productDescription: 'Creator+ Pack',
    features: [
      '57,000 credits per year',
      '7,500 bonus credits',
      '64,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    id: 'production-pack',
    name: 'Production Pack',
    price: '฿17,013.00 / month',
    priceDisplay: '฿17,013.00 / month',
    priceAmount: 204156,
    billingPeriod: 1,
    billingUnit: 'year',
    productDescription: 'Production Pack',
    features: [
      '94,000 credits per year',
      '14,500 bonus credits',
      '108,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    id: 'infinity-pack',
    name: 'Infinity Pack',
    price: '฿27,713.00 / month',
    priceDisplay: '฿27,713.00 / month',
    priceAmount: 332556,
    billingPeriod: 1,
    billingUnit: 'year',
    productDescription: 'Infinity Pack',
    features: [
      '155,400 credits per year',
      '25,900 bonus credits',
      '181,300 total credits',
      'Top up after all credits are used',
    ],
  },
];

const PLAN_LOOKUP = PLAN_CATALOG.reduce((accumulator, plan) => {
  accumulator[plan.id] = plan;
  return accumulator;
}, {});

export const getPlanById = (planId) => PLAN_LOOKUP[planId] || null;

export default PLAN_CATALOG;
